"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const cgui_core_atoms_tooltip_1 = require("@campgladiator/cgui-core.atoms.tooltip");
const accessory_item_module_scss_1 = __importDefault(require("./accessory-item.module.scss"));
const AccessoryItem = ({ label, link, newTab, tooltipText, }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: accessory_item_module_scss_1.default.accessoryItemContainer, onClick: () => setShow(!show), onMouseEnter: () => setShow(true), onMouseLeave: () => setShow(false) },
        link ? (react_1.default.createElement("a", { className: accessory_item_module_scss_1.default.link, target: newTab ? "_blank" : "_self", href: link },
            react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall" }, label))) : (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", className: accessory_item_module_scss_1.default.accessoryItem }, label)),
        tooltipText && (react_1.default.createElement(cgui_core_atoms_tooltip_1.Tooltip, { raised: true, arrow: "top", className: (0, classnames_1.default)(accessory_item_module_scss_1.default.itemListHeader, accessory_item_module_scss_1.default.toolTipCard, {
                [accessory_item_module_scss_1.default.show]: show,
            }) },
            react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", weight: "book", className: accessory_item_module_scss_1.default.toolTipText }, tooltipText)))));
};
exports.default = AccessoryItem;
//# sourceMappingURL=accessory-item.js.map